import { styled } from '@mui/material/styles';
import { Box, Grid2, Typography } from '@mui/material';

export const SectionContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    maxWidth: 1200,
    textAlign: 'center',
    margin: '0 auto',
    paddingTop: 0,

    '& strong': {
        color: '#C28121',
        fontWeight: 600,
    },
}));

export const ImageBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));

export const FloatingTickets = styled('div')(({ theme }) => ({
    position: 'absolute',
    bottom: -110,
    left: '40%',
    transform: 'translateX(-50%)',
    width: 'auto',
    '& img': {
        width: 280,
        maxWidth: '100%',
        transform: 'rotate(-5deg)',
    },
    [theme.breakpoints.down('md')]: {
        bottom: -30,
        '& img': {
            width: 140,
            transform: 'rotate(0deg)',
        },
    },
}));

export const ResponsiveGridItem = styled(Grid2)(({ tabletOrder }) => ({
    order: 0,
    '@media (max-width:960px)': {
        order: tabletOrder || 0,
    },
}));

export const SectionBox = styled(Box)(({ theme }) => ({
    margin: '0 auto',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    padding: '0 16px',
    maxWidth: 600,
    color: '#333',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
        margin: 0,
        padding: '0 24px',
    },
}));

export const SectionTitle = styled(Typography)(({ theme, isMobile }) => ({
    fontWeight: 'bold',
    color: '#101f67',
    fontSize: isMobile ? 22 : 28,
    textAlign: isMobile ? 'center' : 'left',
    marginBottom: theme.spacing(2),
}));

export const SectionText = styled(Typography)(({ theme }) => ({
    fontSize: 16,
    lineHeight: 1.6,
    textAlign: 'justify',
    [theme.breakpoints.up('sm')]: {
        fontSize: 17,
        lineHeight: 1.75,
    },
}));
